// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141331/js/" + chunkId + "." + {"44":"28f7ed3d","225":"eee8f137","481":"80469fd4","486":"0136c251","770":"36a11c42"}[chunkId] + ".0.027175201367324764.chunk.js";
};